import React from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { black } from '../../constants/Colors';
import { screenType } from '../../constants/enum';

const styles = {
  description: {
    marginTop: '16px'
  },
  descriptionText: {
    color: '#757575',
    fontSize: '12px',
    textAlign: 'center'
  },
  title: {
    color: black,
    fontSize: '14px',
    textAlign: 'center'
  }
};

const DeclinePanel = (props: { screen: number }): React.ReactElement => {
  const { t } = useTranslation();
  const { screen } = props;
  return (
    <>
      <Typography sx={styles.title}>
        {screen === screenType.publisher
          ? t('message.declineTitlePublisher')
          : t('message.declineTitle')}
      </Typography>
      <Typography sx={styles.description}>
        <Typography sx={styles.descriptionText}>
          {screen === screenType.publisher
            ? t('message.declineMessagePublisher')
            : t('message.declineMessage')}
        </Typography>
      </Typography>
    </>
  );
};
export default DeclinePanel;
